<template>
	<div class="app-wrapper">
		<el-container class="layout-container">
			<!-- 顶部 Header -->
			<el-header class="app-header">
				<div class="header-left">
					<div class="app-logo" @click="$router.push('/home')">
						<!-- 方案 C: 立方包裹 SVG -->
						<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
							class="logo-icon">
							<!-- 顶面 -->
							<path d="M16 6 L26 12 L16 18 L6 12 Z" fill="#fff" fill-opacity="0.3" stroke="#fff"
								stroke-width="2" stroke-linejoin="round" />
							<!-- 左侧面 -->
							<path d="M6 12 L6 22 L16 28 L16 18 Z" fill="#fff" fill-opacity="0.1" stroke="#fff"
								stroke-width="2" stroke-linejoin="round" />
							<!-- 右侧面 -->
							<path d="M26 12 L26 22 L16 28 L16 18 Z" fill="#fff" fill-opacity="0.2" stroke="#fff"
								stroke-width="2" stroke-linejoin="round" />
							<!-- 内部装饰线 -->
							<path d="M16 18 L16 28" stroke="#fff" stroke-width="1.5" stroke-dasharray="2 2" />
						</svg>
						<span class="app-logo-text">掌递宝</span>
					</div>
				</div>

				<div class="header-right">
					<div class="user-info-area">
						<el-avatar :src="userInfo.avatar || defaultAvatar" size="small" class="user-avatar"></el-avatar>
						<el-dropdown trigger="click" @command="handleCommand">
							<span class="el-dropdown-link">
								{{ userInfo.nickName || '用户' }}
								<el-icon class="el-icon--right"><arrow-down /></el-icon>
							</span>
							<template #dropdown>
								<el-dropdown-menu>
									<el-dropdown-item command="key">查看密钥</el-dropdown-item>
									<el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
								</el-dropdown-menu>
							</template>
						</el-dropdown>
					</div>
					<div class="version-tag">v4.5</div>
				</div>
			</el-header>

			<el-container class="main-body">
				<!-- 侧边栏 Aside -->
				<el-aside width="200px" class="app-aside">
					<el-scrollbar>
						<el-menu :default-active="activeIndex" class="el-menu-vertical" background-color="#ffffff"
							text-color="#333" active-text-color="#007aff" :router="true" unique-opened>
							<el-menu-item index="/home">
								<el-icon>
									<House />
								</el-icon>
								<span>首页</span>
							</el-menu-item>

							<el-menu-item index="/query/waybill">
								<el-icon>
									<Search />
								</el-icon>
								<span>查轨迹</span>
							</el-menu-item>

							<el-sub-menu index="/order">
								<template #title>
									<el-icon>
										<Box />
									</el-icon>
									<span>打单发货</span>
								</template>
								<el-menu-item index="/order/createOrder">创建订单</el-menu-item>
								<el-menu-item index="/order/orderImport">批量导入订单</el-menu-item>
								<el-menu-item index="/order/orderList">订单列表</el-menu-item>
							</el-sub-menu>

							<el-sub-menu index="/tool">
								<template #title>
									<el-icon>
										<Tickets />
									</el-icon>
									<span>客服工具</span>
								</template>
								<el-menu-item index="/tool/workOrder">拦截退更</el-menu-item>
								<el-menu-item index="/tool/stopQuery">停发查询</el-menu-item>
								<el-menu-item index="/tool/orgInfo">网点查询</el-menu-item>
								<el-menu-item index="/tool/goodsRestrictions">禁限寄查询</el-menu-item>
								<el-menu-item index="/tool/againPrint">运单补打</el-menu-item>
							</el-sub-menu>
							<el-sub-menu index="/data">
								<template #title>
									<el-icon>
										<Tickets />
									</el-icon>
									<span>数据统计</span>
								</template>
								<el-menu-item index="/data/subscriptionList">订阅列表</el-menu-item>
								<el-menu-item index="/data/scanList">扫描清单</el-menu-item>
								<el-menu-item index="/data/earlyWarning">环节预警</el-menu-item>
								<el-menu-item index="/data/routeData">运输统计</el-menu-item>
							</el-sub-menu>
							<el-sub-menu v-if="tese" index="/t1">
								<template #title>
									<el-icon>
										<Tickets />
									</el-icon>
									<span>运输管理</span>
								</template>
								<el-menu-item index="">预约用车</el-menu-item>
								<el-menu-item index="">创建运输</el-menu-item>
								<el-menu-item index="">运输管理</el-menu-item>
								<el-menu-item index="">线路监控</el-menu-item>
								<el-menu-item index="">联运大屏</el-menu-item>
							</el-sub-menu>
							<el-sub-menu v-if="tese" index="/t4">
								<template #title>
									<el-icon>
										<Tickets />
									</el-icon>
									<span>逆向寄件</span>
								</template>
							</el-sub-menu>
							<el-sub-menu v-if="tese" index="/t2">
								<template #title>
									<el-icon>
										<Tickets />
									</el-icon>
									<span>国际出口</span>
								</template>
							</el-sub-menu>
							<el-sub-menu v-if="tese" index="/t3">
								<template #title>
									<el-icon>
										<Tickets />
									</el-icon>
									<span>协同任务</span>
								</template>
							</el-sub-menu>
							<el-sub-menu index="/finance">
								<template #title>
									<el-icon>
										<Money />
									</el-icon>
									<span>财务结算</span>
								</template>
								<el-menu-item index="/finance/customerList">客户管理</el-menu-item>
								<el-menu-item index="/finance/priceList">客户价格</el-menu-item>
								<el-menu-item index="/finance/calculateCarriage">账单生成</el-menu-item>
								<el-menu-item index="/finance/billList">客户账单</el-menu-item>
							</el-sub-menu>

							<el-sub-menu index="/set">
								<template #title>
									<el-icon>
										<Setting />
									</el-icon>
									<span>设置</span>
								</template>
								<el-menu-item index="/set/expressAccount">电子面单</el-menu-item>
								<el-menu-item index="/set/downloadList">下载中心</el-menu-item>
								<el-menu-item index="/set/publicDoc">公开文件</el-menu-item>
							</el-sub-menu>

							<el-menu-item index="/queryWaybill">
								<el-icon>
									<Document />
								</el-icon>
								<span>内网运单</span>
							</el-menu-item>
						</el-menu>
					</el-scrollbar>
				</el-aside>

				<!-- 主内容区 Main -->
				<el-main class="app-main">
					<transition name="fade-transform" mode="out-in">
						<router-view></router-view>
					</transition>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	export default {
		name: 'MainFrame',
		data() {
			return {
				activeIndex: '/home',
				userInfo: {},
				defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
				tese:false
			};
		},
		watch: {
			$route(to) {
				this.activeIndex = to.path;
			}
		},
		methods: {
			handleCommand(command) {
				if (command === 'key') this.getKey();
				else if (command === 'logout') this.logOut();
			},
			getKey() {
				const jwtToken = localStorage.getItem('Authorization');
				if (!jwtToken) {
					this.$message.warning('未找到登录凭证');
					return;
				}
				this.$alert(jwtToken, '您的KEY:', {
					confirmButtonText: '复制',
					callback: action => {
						if (action === 'confirm') this.copyToClipboard(jwtToken);
					}
				});
			},
			copyToClipboard(text) {
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(text).then(() => this.$message.success('复制成功'));
				} else {
					const textarea = document.createElement('textarea');
					textarea.value = text;
					document.body.appendChild(textarea);
					textarea.select();
					try {
						document.execCommand('copy');
						this.$message.success('复制成功');
					} catch (err) {
						this.$message.error('复制失败');
					}
					document.body.removeChild(textarea);
				}
			},
			async logOut() {
				const loading = this.$loading({
					lock: true,
					text: '正在退出...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				try {
					await new Promise(resolve => setTimeout(resolve, 800));
					localStorage.clear();
					sessionStorage.clear();
					this.$message({
						message: '退出成功',
						type: 'success',
						center: true
					});
					setTimeout(() => this.$router.push('/login'), 500);
				} catch (error) {
					console.error(error);
					this.$message.error('退出异常');
				} finally {
					loading.close();
				}
			},
			fetchUserInfo() {
				this.apiService.post({
					modules: "userInfo",
					content: {}
				}).then((res) => {
					if (res.status && res.data) {
						this.userInfo = res.data;
						window.localStorage.setItem("userInfo", JSON.stringify(res.data));
					}
				});
			}
		},
		created() {
			const localUser = window.localStorage.getItem("userInfo");
			if (localUser) {
				try {
					this.userInfo = JSON.parse(localUser);
				} catch (e) {
					console.error(e);
				}
			}
		},
		mounted() {
			this.activeIndex = this.$route.path;
			this.fetchUserInfo();
		}
	};
</script>

<style lang="scss" scoped>
	.app-wrapper {
		height: 100vh;
		width: 100vw;
		overflow: hidden;
		background-color: #f5f7fa;
	}

	.layout-container {
		height: 100%;
	}

	.app-header {
		background-color: #007aff;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		z-index: 10;
		--el-header-padding: 0;
		--el-header-height: 50px;
	}

	.header-left {
		display: flex;
		align-items: center;
	}

	.app-logo {
		display: flex;
		align-items: center;
		gap: 10px;
		cursor: pointer;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.9;
		}

		.logo-icon {
			filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
		}

		.app-logo-text {
			font-size: 18px;
			font-weight: 600;
			letter-spacing: 1.5px;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
		}
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 20px;
	}

	.user-info-area {
		display: flex;
		align-items: center;
		gap: 10px;
		cursor: pointer;
		padding: 4px 8px;
		border-radius: 4px;
		transition: background-color 0.3s;

		&:hover {
			background-color: rgba(255, 255, 255, 0.1);
		}

		.user-avatar {
			border: 1px solid rgba(255, 255, 255, 0.3);
		}

		.el-dropdown-link {
			color: #fff;
			display: flex;
			align-items: center;
			font-size: 14px;

			&:focus {
				outline: none;
			}
		}
	}

	.version-tag {
		font-size: 12px;
		opacity: 0.8;
		background: rgba(0, 0, 0, 0.1);
		padding: 2px 6px;
		border-radius: 4px;
	}

	.main-body {
		height: calc(100% - 50px);
	}

	.app-aside {
		background-color: #fff;
		border-right: 1px solid #e6e6e6;
		transition: width 0.3s;

		.el-scrollbar {
			height: 100%;
		}

		::v-deep .el-scrollbar__bar.is-vertical {
			width: 6px;
		}
	}

	.el-menu-vertical {
		border-right: none;
		height: 100%;

		::v-deep .el-menu-item,
		::v-deep .el-sub-menu__title {
			height: 45px;
			line-height: 45px;
			margin: 4px 8px;
			border-radius: 6px;

			&:hover {
				background-color: #ecf5ff !important;
				color: #007aff !important;
			}
		}

		::v-deep .el-menu-item.is-active {
			background-color: #ecf5ff !important;
			color: #007aff !important;
			font-weight: 500;
		}

		::v-deep .el-sub-menu__title:hover {
			background-color: transparent !important;
		}
	}

	.app-main {
		background-color: #f0f2f5;
		padding: 20px;
		overflow-y: auto;
	}

	.fade-transform-enter-active,
	.fade-transform-leave-active {
		transition: all 0.3s ease;
	}

	.fade-transform-enter-from {
		opacity: 0;
		transform: translateX(-10px);
	}

	.fade-transform-leave-to {
		opacity: 0;
		transform: translateX(10px);
	}
</style>